module.exports = __webpack_public_path__ + "static/redbull-532ad946e7440fb0f8341493fdc98013.png";